define('components/colorPicker/viewmodel',
    [
        'components/colorPicker/model',
        'mixins/withEffects',
        'libraries/spectrum',
        './template.html',
        './styles.scss'
    ],

    function (Model, { withEffects }) {
        const colorService = require('helpers/color').ColorHelpers;

        function ViewModel(model, info) {
            var mEffects = withEffects();

            var oIsActive = ko.observable(false),
                oSpectrumNode = ko.observable(null);

            var cValue = model.value,
                oColor = ko.observable('#fff');

            function toggle() {
                oIsActive(!oIsActive());
            }

            function centerSpectrum() {
                var width = info.element.clientWidth,
                    offset = Math.floor(width / 2);

                $(oSpectrumNode())
                    .spectrum('container')
                    .css({ 'transform': 'translateX(-50%) translateX(' + offset + 'px) translateY(-10px)' });
            }

            function resetSpectrumPosition() {
                $(oSpectrumNode())
                    .spectrum('container')
                    .css({ 'transform': '' });
            }

            function onChange(value) {
                if (!colorService.compare(value, cValue()))
                    model.onPick(value);
            }

            function onInit(element) {
                var $anchor = $(element),
                    $container = $anchor.spectrum('container');

                $container.wrapInner('<div class="wcc-colorpicker__spectrum__body"></div>');

                var $body = $container.find('.wcc-colorpicker__spectrum__body');

                ko.applyBindingsToNode($body[0], {
                    'appear': {
                        'visible': oIsActive,
                        'show-animation': 'zoomIn',
                        'hide-animation': 'zoomOut',
                        'duration': 350,
                        'on-start': function (context) {
                            var isVisible = context.state;

                            if (isVisible) {
                                if ($container.hasClass('sp-hidden')) {
                                    resetSpectrumPosition();
                                    $anchor.spectrum('show');
                                }
                            } else {
                                if (!$container.hasClass('sp-hidden'))
                                    $anchor.spectrum('hide');
                            }
                        }
                    }
                });
            }

            function onShow() {
                oIsActive(true);
                centerSpectrum();
            }

            function onHide() {
                oIsActive(false);
                model.onHide();
            }

            mEffects.register([
                oColor.subscribe(onChange)
            ]);

            mEffects.register(function (value) {
                oColor(value);
            }, [cValue]);

            ko.applyBindingsToNode(info.element, {
                'click': toggle,

                'css': {
                    'wcc-colorpicker': true
                }
            });

            this.color = oColor;
            this.spectrumNode = oSpectrumNode;

            this.onInit = onInit;
            this.onShow = onShow;
            this.onHide = onHide;
            this.dispose = mEffects.dispose;
        }

        ViewModel.Model = Model;

        return ViewModel;
    });